import type { Bounds } from "@core/types";

/** Скорость игрока без glow (% в секунду). */
export const PLAYER_SPEED_NORMAL = 12;
/** Скорость игрока с активным glow (% в секунду). */
export const PLAYER_SPEED_GLOW = 10;
/** Границы движения игрока (% от размера stage). */
export const PLAYER_BOUNDS: Bounds = { x: [6, 94], y: [14, 91] };

/** Радиус обнаружения семян при glow (% единицы). */
export const SEED_REVEAL_RADIUS = 22;
/** Радиус сбора семени (% единицы). Просторнее — на тач-устройствах легче дойти. */
export const SEED_COLLECT_RADIUS = 6.5;
/** Радиус сбора glow-sand (% единицы). */
export const SAND_COLLECT_RADIUS = 5.0;
/** Радиус использования цветка (% единицы). */
export const FLOWER_USE_RADIUS = 6.5;
/** Бонус энергии от glow-sand (%). */
export const SAND_ENERGY_BONUS = 18;
/** Бонус энергии от glow-flower (%). */
export const FLOWER_ENERGY_BONUS = 36;

/** Радиус сбора glowfly (% единицы). Чуть просторнее, чтобы не гонять долго. */
export const GLOWFLY_COLLECT_RADIUS = 5.5;
/** Бонус энергии от glowfly (%). */
export const GLOWFLY_ENERGY_BONUS = 12;
/** Радиус орбиты glowfly вокруг basePosition (% единицы). */
export const GLOWFLY_ORBIT_RADIUS = 3.4;
/** Угловая скорость orbit (рад/сек). */
export const GLOWFLY_ORBIT_SPEED = 0.9;

/** Скорость расхода энергии при активном glow (%/сек). */
export const GLOW_DRAIN_RATE = 7.5;
/** Скорость восстановления энергии в calm-spot (%/сек). */
export const CALM_REFILL_RATE = 18;

/** Количество семян для завершения уровня. */
export const TOTAL_SEEDS = 5;

/** Позиция calm-spot (% от stage). */
export const CALM_SPOT_POSITION = { x: 18, y: 71 } as const;
/** Радиус calm-spot (% единицы). */
export const CALM_SPOT_RADIUS = 8.5;
/** Позиция garden-center (% от stage). */
export const GARDEN_CENTER_POSITION = { x: 50, y: 52 } as const;
/** Радиус garden-center (% единицы). */
export const GARDEN_CENTER_RADIUS = 7.4;
